const AnalysisIndex = () => import("@/pages/lab/analysis/AnalysisIndex");
const AnalysisDetail = () => import("@/pages/lab/analysis/AnalysisDetail");
const AnalysisAdd = () => import("@/pages/lab/analysis/AnalysisAdd");
const AnalysisEdit = () => import("@/pages/lab/analysis/AnalysisEdit");
const AnalysisSingle = () => import("@/pages/lab/analysis/AnalysisSingle");
const AnalysisAuditTrail = () => import("@/pages/lab/analysis/AnalysisAuditTrail");
const AnalysisAuditTrailHistory = () => import("@/pages/lab/analysis/AnalysisAuditTrailHistory");

export class AnalysisRoutes {
  constructor() {
    this.route_root = "analysis";
    this.type_single = "Analysis";
    this.type_plural = "Analysis";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c('router-view')
          }
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: `List ${this.type_plural}`,
            component: AnalysisIndex,
            meta: { requiresAuth: true }
          },
          {
            path: "add",
            name: `Add ${this.type_single}`,
            component: AnalysisAdd,
            meta: { requiresAuth: true }
          },
          {
            path: ":analysis_id",
            component: AnalysisSingle,
            children: [
              {
                path: "",
                name: `View ${this.type_single}`,
                component: AnalysisDetail,
                meta: { requiresAuth: true }
              },
              {
                path: "edit",
                name: `Update ${this.type_single}`,
                component: AnalysisEdit,
                meta: { requiresAuth: true }
              },
              {
                path: "audit-trail",
                name: `${this.type_single} Audit Trail`,
                component: AnalysisAuditTrail,
                meta: { requiresAuth: true }
              },
              {
                path: "audit-trail-history",
                name: `${this.type_single} Audit Trail History`,
                component: AnalysisAuditTrailHistory,
                meta: { requiresAuth: true }
              }
            ]
          }
        ]
      }
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
